<template>
  <div id="nova">
    <MainHeader />

    <!-- Content -->
    <div dusk="content" class="mt-[4.5rem]">

      <div class="w-[16rem] 2xl:left-[47px] hidden 2xl:flex flex-wrap sticky top-[70px] mt-[-34px] z-10">
          <EadgeContainer
            containerClass="bg-[#FAFAFA] dark:bg-gray-700 w-full h-[40px] flex flex-row justify-between items-center"
            :firstEdgeClass="`fill-[#FAFAFA] dark:fill-gray-700 h-[49px] md:h-[40px] relative z-[2] -right-[-10px] ${isRTL ? '-scale-x-100' : ''} w-auto`"
            :secondEdgeClass="`fill-[#FAFAFA] dark:fill-gray-700 h-[49px] md:h-[40px] relative z-[2] -left-[-10px] ${!isRTL ? '-scale-x-100' : ''} w-auto`"
          >
            <template #content>
              {{currentUser?.email ?? currentUser?.phone_number}}
            </template>
          </EadgeContainer>
        </div>

      <div
        ref="sidebarMenuRef"
        class="hidden bg-sidebar overflow-hidden  bottom-0  left-0  2xl:block 2xl:fixed 2xl:rounded-2xl 2xl:left-[47px] 2xl:top-[140px] 2xl:bottom-[25px]
          w-[16rem] px-3  py-5
        "
      >
        <!-- The Main Menu on desktop gets extra padding to keep the bottom of the sidebar from feeling crowded -->
        <MainMenu class="pb-24" data-screen="desktop" :menu-height.sync="sidebarMenuHeight" />
        <div 
          class="w-full shadow-[0_8px_32px_0_rgba(147,197,253,0.15)] dark:shadow-md h-[50px] bg-primary-300/10 dark:bg-primary-400/10 backdrop-blur-md border border-primary-300/30 dark:border-primary-400/30 mt-[-80px] rounded-2xl flex items-center justify-center" 
          dir="ltr" 
        >
          <span class="text-primary-500 dark:text-primary-400 pt-2 text-xl font-bold">
            {{ appName }}
          </span>
          <img src="/images/logo.png" class="w-[50px] h-[50px]">
        </div>
      </div>



      <div class="p-4 md:py-8 md:px-12 2xl:ml-[20rem] space-y-8">

        <div class="w-full flex flex-wrap sticky 2xl:top-[69px] top-[68px] mt-[-40px] z-10 px4 2xl:px-0">
          <EadgeContainer
            containerClass="bg-[#FAFAFA] dark:bg-gray-700 md:w-full mx-auto w-[92%] h-[45px] flex flex-row justify-between items-center"
            :firstEdgeClass="`fill-[#FAFAFA] dark:fill-gray-700 h-[45px] md:h-[45px] relative z-[2] -right-[-10px] ${isRTL ? '-scale-x-100' : ''} w-auto`"
            :secondEdgeClass="`fill-[#FAFAFA] dark:fill-gray-700 h-[45px] md:h-[45px] relative z-[2] -left-[-10px] ${!isRTL ? '-scale-x-100' : ''} w-auto`"
          >
            <template #content>
              <Breadcrumbs class="w-full overflow-hidden" v-if="breadcrumbsEnabled" />
            </template>
          </EadgeContainer>
        </div>

        

        <FadeTransition>
          <slot />
        </FadeTransition>

        <Footer />
      </div>
    </div>
    <PWAInstallPrompt />
    <PWAUpdatePrompt />
  </div>
</template>

<script>
import MainHeader from '@/layouts/MainHeader'
import Footer from '@/layouts/Footer'
import PWAInstallPrompt from '@/components/PWAInstallPrompt'
import PWAUpdatePrompt from '@/components/PWAUpdatePrompt'

export default {
  components: {
    MainHeader,
    Footer,
    PWAInstallPrompt,
    PWAUpdatePrompt,
  },

  data() {
    return {
      sidebarMenuHeight: 600, // default height
    }
  },

  mounted() {
    Nova.$on('error', this.handleError)
    Nova.$on('token-expired', this.handleTokenExpired)
    
    // Calculate sidebar menu height after DOM is mounted
    this.$nextTick(() => {
      this.updateSidebarMenuHeight()
      
      // Add resize listener
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.updateSidebarMenuHeight)
      }
    })
  },

  beforeUnmount() {
    Nova.$off('error', this.handleError)
    Nova.$off('token-expired', this.handleTokenExpired)
    
    // Remove resize listener
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateSidebarMenuHeight)
    }
  },

  methods: {
    handleError(message) {
      Nova.error(message)
    },

    handleTokenExpired() {
      // @TODO require Nova._createToast() to support action with link.
      Nova.$toasted.show(this.__('Sorry, your session has expired.'), {
        action: {
          onClick: () => Nova.redirectToLogin(),
          text: this.__('Reload'),
        },
        duration: null,
        type: 'error',
      })

      setTimeout(() => {
        Nova.redirectToLogin()
      }, 5000)
    },
    
    updateSidebarMenuHeight() {
      // Wait for next tick to ensure DOM is updated
      this.$nextTick(() => {
        if (this.$refs.sidebarMenuRef) {
          // Get the actual height of the sidebar menu container
          const height = this.$refs.sidebarMenuRef.clientHeight
          // Subtract padding (py-5 = 20px top + 20px bottom = 40px) and logo height (50px)
          // Also account for the MainMenu's pb-24 (96px padding bottom)
          this.sidebarMenuHeight = height
        } else if (typeof window !== 'undefined' && window.innerWidth >= 1536) {
          // Fallback: calculate based on viewport if ref is not available
          // top: 140px, bottom: 25px, padding: 40px, logo: 50px, menu padding: 96px
          this.sidebarMenuHeight = window.innerHeight - 140 - 25 - 40 - 50 - 96
        }
      })
    },
  },

  computed: {
    appName() {
      return Nova.config('appName')
    },

    currentUser() {
      return this.$store.getters.currentUser
    },
    isRTL() {
      return Nova.config('rtlEnabled')
    },
    breadcrumbsEnabled() {
      return Nova.config('breadcrumbsEnabled')
    },
  },
}
</script>
